import React from 'react';
import PropTypes from 'prop-types';
import { MdMoreHoriz } from 'react-icons/md';
import { BsChat, BsUpload, BsBag } from 'react-icons/bs';
import { RiShareForwardLine } from 'react-icons/ri';
import { IoMdHeartEmpty } from 'react-icons/io';
import './HaesCard.css';

import verified from '../../assets/badge-influencer.svg';

const HaesCard = ({ image, badge, username, name, time, occupation, haes }) => {
  return (
    <article className="haes">
      <div className="haes__content">
        <div className="flex flex-jc-sb">
          <div className="flex flex-ai-c">
            <div className="image">
              <img src={image} alt="User" />
            </div>
            <div>
              <div>
                <div className="flex user">
                  <h4>{name}</h4>
                  {badge && <img src={verified} alt="badge" />}
                  <p>{username}</p>
                  <p>{time}</p>
                </div>
              </div>
              <div className="flex">
                <BsBag className="icon icon--xs" />
                <p>{occupation}</p>
              </div>
            </div>
          </div>
          <div>
            <MdMoreHoriz className="icon--md" />
          </div>
        </div>
        <div className="p-vertical">
          <p>{haes}</p>
        </div>
      </div>
      <div className="flex flex-jc-sb haes__icons">
        <div className="clickable flex flex-ai-c">
          <BsChat className="icon icon--sm" />

          <p>1.1k</p>
        </div>
        <div className="clickable flex flex-ai-c">
          <RiShareForwardLine className="icon" />

          <p>3.8k</p>
        </div>
        <div className="clickable flex flex-ai-c">
          <IoMdHeartEmpty className="icon" />

          <p>8.5k</p>
        </div>
        <div className="clickable flex flex-ai-c">
          <BsUpload size={20} />
        </div>
      </div>
    </article>
  );
};

HaesCard.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  username: PropTypes.string,
  badge: PropTypes.bool,
  time: PropTypes.string,
  occupation: PropTypes.string,
  haes: PropTypes.string,
};

HaesCard.defaultProps = {
  image:
    'https://i0.wp.com/www.repol.copl.ulaval.ca/wp-content/uploads/2019/01/default-user-icon.jpg',
  name: 'Laolu Onifade',
  username: '#isLaolu',
  badge: false,
  time: '8hrs',
  occupation: 'Music Artiste',
  haes: 'Counting down to #LIVIDSPACETHEALBUM release date. Check my bio to Pre-Order',
};

export default HaesCard;
